<template>
  <div class="container mt-3">
    <div v-if="data">
      <div class="row">
        <div class="col-6">
          <div class="card">
            <div class="card-header">
              <h5 class="mb-0">Resultados</h5>
            </div>
            <div class="card-body">
              <b-form-group class="d-flex justify-content-end mb-3">
                <b-input-group size="sm" style="width: 300px;">
                  <b-form-input
                    id="filter-input"
                    v-model="filter"
                    type="search"
                    placeholder="Buscar en tabla..."
                    class="float-right"
                    @input="clearSelection()"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>

              <b-table
                :items="data"
                :fields="fields"
                :filter="filter"
                :filter-included-fields="filterOn"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                stacked="md"
                show-empty
                small
                striped
                hover
                responsive
                :label-sort-asc="''"
                :label-sort-desc="''"
                :label-sort-clear="''"
                :tbody-tr-class="getRowClass"
              >
                <template #cell(actions)="row">
                  <b-button
                    size="sm"
                    :variant="getDetailsButtonClass(row.item)"
                    :pressed="isUserSelected(row.item)"
                    @click="selectUser(row.item)"
                  >
                    <span v-if="!isUserSelected(row.item)">
                      <i class="fas fa-eye"></i>
                    </span>
                    <span v-else>
                      <i class="fas fa-times"></i>
                    </span>
                  </b-button>
                </template>

                <template #cell(active)="row">
                  <boolean-value :value="row.item.active"></boolean-value>
                </template>

                <template #cell(createdAt)="row">
                  {{ row.item.createdAt | formatDateTime }}
                </template>

                <template #empty>
                  <div class="text-center">
                    <p>No hay registros para mostrar</p>
                  </div>
                </template>

                <template #emptyfiltered>
                  <div class="text-center">
                    <p>No hay registros que coincidan con el filtro</p>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>

        <div class="col-6" v-if="selectedUser">
          <user-details :user="selectedUser" @close="clearSelection"></user-details>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import User from "../models/user";
import BooleanValue from '@/components/BooleanValue.vue';
import UserDetails from '@/components/UserDetails.vue';

export default {
  name: 'list',
  components: {BooleanValue, UserDetails},
  props: {
    data: {
      type: Array,
      default: () => [],
      required: true,
      validator(value) {
        return value.every(item => item instanceof User);
      }
    },
    search: {
      type: String,
      default: '',
      required: true
    }
  },

  data() {
    return {
      filter: null,
      filterOn: [],
      sortBy: 'username',
      sortDesc: false,
      sortDirection: 'asc',
      fields: [
        { key: 'username', label: 'Username', sortable: true },
        { key: 'collectiveName', label: 'Colectivo', sortable: true },
        { key: 'name', label: 'Nombre', sortable: true },
        { key: 'surname', label: 'Apellidos', sortable: true },
        { key: 'actions', label: '', sortable: false }
      ],
      selectedUser: null
    }
  },

  methods: {
    selectUser(user) {
      if (this.selectedUser && this.selectedUser.id === user.id) {
        this.clearSelection();
        return;
      }

      this.selectedUser = user;
    },
    getRowClass(item) {
      if (!item) {
        return '';
      }

      return this.isUserSelected(item) ? 'table-active' : ''
    },
    clearSelection() {
      this.selectedUser = null;
    },
    getDetailsButtonClass(item) {
      return this.isUserSelected(item) ? 'dark' : 'primary';
    },
    isUserSelected(item) {
      return this.selectedUser && this.selectedUser.id === item.id;
    }
  }
}
</script>
